<template>
  <li class="nav-item">
    <a
      v-if="linksCliente[0] !== null && linksCliente[0] !== ''"
      :href="linksCliente[0]"
      target="_blank"
    >
      <b-img
        id="link-1"
        :src="srcIcon()"
        width="21"
        height="21"
      />
      <b-tooltip
        target="link-1"
        triggers="hover"
        title="Abrir link 1"
        placement="top"
      />
    </a>
    <a
      v-if="linksCliente[1] != null && linksCliente[1] != ''"
      :href="linksCliente[1]"
      target="_blank"
    >
      <b-img
        id="link-2"
        :src="srcIcon()"
        width="21"
        height="21"
      />
      <b-tooltip
        target="link-2"
        triggers="hover"
        title="Abrir link 2"
        placement="top"
      />
    </a>
  </li>
</template>

<script>
import { onBeforeMount } from '@vue/composition-api'
import { createNamespacedHelpers } from 'vuex-composition-helpers'
import iconLinkUrl0 from '@/assets/images/icons/icon-link-url-0.svg'

export default {
  name: 'LinksCliente',
  setup() {
    const { useGetters, useActions } = createNamespacedHelpers('links')
    const { links } = useGetters(['links'])
    const { findAll } = useActions(['findAll'])

    onBeforeMount(() => {
      findAll()
    })

    const srcIcon = () => iconLinkUrl0

    return { linksCliente: links, srcIcon }
  },
}

</script>

<style scoped>
.nav-item a {
  padding: 0 0.5rem;
}
</style>